import {
  FocusTrap,
  Text,
  Button,
} from '@mantine/core';
import {
  modals,
} from '@mantine/modals';
import {
  createFileRoute,
} from '@tanstack/react-router';
import React, {
  useState,
} from 'react';

import Subscribe from '#features/payment/Subscribe';

export const Route = createFileRoute('/_app/_authenticated/store/')({
  component: RouteComponent,
});

function RouteComponent(): React.ReactNode {
  const [
    modalId,
    setModalId,
  ] = useState<string>('');
  return (
    <>
      <Button
        onClick={ () => {
          setModalId(
            modals.open({
              withinPortal: true,
              title: (
                <Text
                  size="xl"
                >
                  Subscribe
                </Text>
              ),
              children: (
                <>
                  <FocusTrap.InitialFocus />
                  <Subscribe
                    modalId={ modalId }
                    plan={ {
                      name: 'Pay-as-you-go',
                      description: 'Starts at $7 per client/month',
                      priceId: '',
                    } }
                  />
                </>
              ),
            }),
          );
        } }
      >
        Checkout
      </Button>
    </>
  );
}
